<template>
  <div class="select-region">
    <selectTree
      :data="regionList"
      :multiple="true"
      ref="selectTree"
      :size="null"
      :placeholder="`请选择`"
      :single="true"
      :showParentNode="true"
      :selectAllChildren="true"
      :checkToParent="true"
      :checkAllData="checkAllData"
      :allValue="allValue"
      @check="regionChange"
      v-model="regionArr"
    ></selectTree>
  </div>
</template>

<script>
import selectTree from '@/components/commons/selectTree';
export default {
  components: { selectTree },
  props: {
    value: {
      default() {
        return [];
      }
    },
    checkAllData: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: '/buz/area/treeByLevels'
    },
    requestType: {
      type: String,
      default: 'POST'
    },
    requestParams: {
      type: [Object, Array],
      default: function () {
        return [1, 2];
      }
    }
  },
  data() {
    return {
      load: false,
      regionList: [], //区域数据
      regionArr: [],
      allValue: []
    };
  },
  watch: {
    value: {
      handler(newVal) {
        console.log(newVal);
        if (newVal) {
          this.regionArr = newVal;
          if ((newVal.length == 0 || this.allValue.length != newVal.length) && this.checkAllData) {
            this.$refs.selectTree.checkAll = false;
          }
          if (this.allValue.length > 0 && this.allValue.length == newVal.length && this.checkAllData) {
            this.$refs.selectTree.checkAll = true;
          }
        } else {
          this.regionArr = [];
          if (this.checkAllData) {
            this.$refs.selectTree.checkAll = false;
          }
        }
      }
    },
    deep: true,
    immediate: true
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http({
        url: this.url,
        type: this.requestType,
        data: this.requestParams
      }).then(res => {
        this.allValue = [];
        this.foreachData(res.data);
        this.regionList = res.data;
        this.$emit('init', this.regionList);
      });
    },
    foreachData(list) {
      list.forEach(item => {
        item.value = item.code;
        item.label = item.name;
        item.children = item.childrens;
        this.allValue.push(item.value);
        if (item.children) {
          this.foreachData(item.children);
        }
      });
    },
    regionChange() {
      this.$emit('input', this.regionArr);
      this.$emit('change', this.regionArr);
    }
  }
};
</script>
<style lang="scss" scoped>
.select-region {
  width: 100%;
}
</style>
